
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.223 13.067h.134c.11.542.589.933 1.143.933h1.167c.256 0 .466-.21.466-.467v-5.6a.468.468 0 00-.466-.466H3.5c-.554 0-1.033.39-1.143.933h-.49V7A6.07 6.07 0 017.933.933 6.07 6.07 0 0114 7v1.4h-.49a1.168 1.168 0 00-1.143-.933H11.2a.468.468 0 00-.467.466v5.6c0 .257.21.467.467.467h1.167c.554 0 1.032-.39 1.143-.933h1.073c.706 0 1.284-.578 1.284-1.284v-2.1c0-.571-.38-1.079-.934-1.236V7c0-3.868-3.132-7-7-7-3.867 0-7 3.132-7 7v1.447A1.281 1.281 0 000 9.683v2.1c0 .706.578 1.284 1.283 1.284h.94zm1.044-.467V8.633c0-.128.105-.233.233-.233h.7v4.667h-.7a.234.234 0 01-.233-.234V12.6zM12.6 8.867v3.966a.234.234 0 01-.233.234h-.7V8.4h.7c.128 0 .233.105.233.233v.234zm2.333.816v2.1a.35.35 0 01-.35.35h-1.05v-2.8h1.05c.193 0 .35.158.35.35zm-13.65 2.45a.351.351 0 01-.35-.35v-2.1c0-.192.158-.35.35-.35h1.05v2.8h-1.05z","fill":"#000"}})])
          )
        }
      }
    